<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <!--<div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["BTN"]["AN"] }}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["CPR"]["TFI"] }} <span class="required" /> :</label>
                                            <CInput size="sm" :value="obj_ab.TI" placeholder="" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TI','TI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["CPR"]["TF"] }} <span class="required" /> :</label>
                                            <CInput size="sm" :value="obj_ab.TO" placeholder="" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TO','TO') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ getLanguage["TD"]["TT2"] }} <span class="required" /> :</label>
                                            <CInput size="sm" :value="obj_ab.WD" placeholder="" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('WD','WD') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ this.getLanguage["CPR"]["S"] }} <span class="required" /> :</label>
                                            <CInput size="sm" :value="obj_ab.SV" placeholder="" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('SV','SV') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{ this.getLanguage["PM"]["RM"] }}:</label>
                                            <textarea class="form-control form-control-sm" vertical="" rows="4" :value="obj_ab.RM" @change="TextValueChange('R',$event)" v-shortkey.avoid></textarea>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                </div>
                                <label class="mandatory_Field">{{ this.getLanguage['MANDATORY']['FIELDS'] }}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["SMB"]["CPR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content p-0">
                                    <div class="pb-3">
                                        <CCol>
                                            <CRow>
                                                <CCol col="3" v-for="(month,index) in arry_lastmonth" v-bind:key="index" @click="showDetailsByPirodMonth(obj_details,month)">
                                                    <CButton class='mr-auto w-100' size="sm" :color="selectedStyle(month)">
                                                        <span> {{ formatMonth(month) }} </span>
                                                    </CButton>
                                                </CCol>
                                                <CCol col="3">
                                                    <CButton class='mr-auto w-100' size="sm" :color="selectedStyle(defaultMonth)" @click="showDetailsByPirodMonth(defaultDetail,defaultMonth)">
                                                        <span> {{ formatMonth(defaultMonth) }} </span>
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>-->

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">
                            {{checkModuleIndex('CPR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["SMB"]["CPR"]}}
                        </h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="str_FV[0].FV"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["CPR"]["BM"]}} :</span>
                                <vue-monthly-picker v-model="str_FV[1].FV"
                                                    :clearOption="false"
                                                    selectedBackgroundColor="blue">
                                </vue-monthly-picker>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class="table-wrapper with_page">
                <header class="table-header">
                    <strong>
                        {{this.getLanguage["SMB"]["CPRL"]}}
                    </strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage[["GL"]]["NO"]}}</th>
                                <th class="tableCtnCenter">{{ getLanguage["DB"]["A"] }}</th>
                                <th v-if="!hideBrand">{{ getLanguage["AFF"]["BN"] }}</th>
                                <th>{{ getLanguage["AN"]["DT"] }}</th>
                                <th class="tableCtnRight">{{ getLanguage["MTA"]["FTA"] }}</th>
                                <th class="tableCtnCenter">{{ getLanguage["N"]["ST"] }}</th>
                                <th>{{ getLanguage["BAL"]["LU"] }}</th>
                                <th>{{ getLanguage["CPR"]["UB"] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="!hideBrand && !str_FV[0].FV">{{ this.getLanguage['GL']['PSAA'] }}</td>
                        <td colspan="100%" v-else-if="arr_CashPositionReportList && arr_CashPositionReportList.length == 0">{{ this.getLanguage['GL']['NR'] }}</td>
                        <tr v-for="(data,index) in arr_CashPositionReportList">
                            <td>{{ CountItem(index+1)}}</td>
                            <td>
                                <span id="actionBtnCol">
                                    <div v-if="data.RS == 2 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-description" @click='cashPositionDetail(formatDateTime(data.LD, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD"), data.AGI )'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <div v-else-if="data.RS == 2 && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-description"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <div v-else-if="checkModuleAccess2(constAccessType.edit)  && data.RS != 2 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-color-border" @click='cashPositionDetail(formatDateTime(data.LD, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD"), data.AGI )'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-else-if="checkModuleAccess2(constAccessType.edit)  && data.RS != 2 && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td v-if="!hideBrand">{{ data.GN }}</td>
                            <td>{{ formatDateTime(data.LD, "YYYY-MM-DD", "DD MMM YYYY") }}</td>
                            <td class="tableCtnRight">
                                <span v-if="data.LTA !== 0">
                                    <span v-if="!checkWholeNumber(data.LTA)" :class="data.LTA > 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.LTA, 0, data.CS) }}
                                    </span>
                                    <span v-else :class="data.LTA > 0? 'positive-number': 'negative-number'">
                                        {{ formatNumber(data.LTA, 2, data.CS) }}
                                    </span>
                                </span>
                            </td>
                            <td class="tableCtnCenter">
                                <span v-if="( data.RS != null && data.RS !==0 )">
                                    <span v-if="data.RS ==1" class="text-darkOrange">
                                        {{ renderStatus(data.RS) }}
                                    </span>
                                    <span v-else-if="data.RS ==2" class="text-green">
                                        {{ renderStatus(data.RS) }}
                                    </span>
                                    <span v-else-if="data.RS ==3" class="text-red">
                                        {{ renderStatus(data.RS) }}
                                    </span>
                                    <span v-else>
                                        {{ renderStatus(data.RS) }}
                                    </span>
                                </span>
                            </td>
                            <td>
                                <span v-if="( data.UTS != null && data.UTS != '0001-01-01T00:00:00' )">
                                    {{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </span>
                                <span v-else>
                                    &nbsp;
                                </span>
                            </td>
                            <td>{{ data.UB }}</td>
                        </tr>
                        <tr class="cp-sticky afb-blue tableCtnRight">
                            <th colspan="4">{{ getLanguage["CPR"]["TOTAL"] }}</th>
                            <th>
                                <span v-if="totalDayAmount !== 0">
                                    <span v-if="!checkWholeNumber(totalDayAmount)" :class="totalDayAmount > 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(totalDayAmount, 0, currencySymbol) }}
                                    </span>
                                    <span v-else :class="totalDayAmount > 0? 'cp-positive': 'cp-negative'">
                                        {{ formatNumber(totalDayAmount, 2, currencySymbol) }}
                                    </span>
                                </span>
                            </th>
                            <th colspan="3">&nbsp;</th>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>&nbsp;</div><div>&nbsp;</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import { constAccessType, constRequestStatus, loadingFullScreen } from '@/modules/Constant.js';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import DateRangePicker from 'vue2-daterange-picker';
    import Vue from 'vue'
    import VueMonthlyPicker from 'vue-monthly-picker';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            VueMonthlyPicker,
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showSearchBar: true,
                bool_showDetails: false,
                bool_isAMV: false,
                str_FV: [
                    { F: "AGI" },
                    { F: "BM", FV: moment(new Date(new Date().getFullYear(), new Date().getMonth())) }
                ], //Filter Value
                arr_CashPositionReportList: [],
                dd_currency: [],
                dd_agentgroup: [],
                ddMemberList: [],
                constAccessType: constAccessType,
                obj_ab: {
                    I: 0,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: 0,
                    TI: 0,
                    TO: 0,
                    WD: 0,
                    SV: null,
                    RM: null
                },
                obj_details: {},
                arry_lastmonth: [],
                defaultDetail: {},
                defaultMonth: null,
                activeMonth: null,
                hideBrand: false,
            }
        },
        validations: {
            obj_ab: {
                TI: { required },
                TO: { required },
                WD: { required }
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),


            currencySymbol: function () {
                var CS = "";
                this.arr_CashPositionReportList.forEach(e => {
                    if (e.CS!=null) {
                        CS= e.CS;
                    }
                    
                });
                return CS;

            },
            totalDayAmount: function () {
                var sum = 0;
                if (this.arr_CashPositionReportList && this.arr_CashPositionReportList.length > 0) {
                    this.arr_CashPositionReportList.forEach(e => {
                        sum += e.LTA;
                    });
                }
                return sum;
            },

        },
        created() {
            this.$parent.showSubMenu = "R";
            this.$parent.showActiveMenu = "R.CPR";
            if (this.checkModuleIndex('CPR', 'R', constAccessType.view, '', -1) == '7.2.9') {
                this.$parent.showSubSubMenu = 'RS2';
            } else if (this.checkModuleIndex('CPR', 'R', constAccessType.view, '', -1) == '7.5.5') {
                this.$parent.showSubSubMenu = 'RS5';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.str_FV[0].FV = this.$route.query.agi;

            this.getAgentGroup();
            this.getTTList();
            this.getCurrencyList();
            let that = this;
            window.reloadList = function () {
                that.getCashPositionList();
            }
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getTTList();
            },
        },
        methods: {
            cashPositionDetail(rdate, agi) {
                let routeData = this.$router.resolve({ path: '/R/CPR/CPRD?agi=' + agi + '&rDate=' + rdate });
                window.open(routeData.href, '_blank');
            },
            alertTest() {
                alert('alertTest');
            },
            showDetails(data) {
                //this.arry_details = [];
                //this.bool_fullLoading = true;
                //this.obj_details = Object.assign(this.obj_details, data);
                //this.defaultDetail = Object.assign(this.defaultDetail, data);

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'BM' && this.str_FV[i].FV != '') {
                            var from_date = this.parseDateToJsonString(this.str_FV[i].FV);
                            var to_date = moment(from_date).endOf('month').format('YYYY-MM-DD hh:mm');

                            path += "&f[CTS_from]=" + from_date;
                            path += "&f[CTS_to]=" + to_date;

                            that.defaultMonth = from_date;
                            that.activeMonth = from_date;

                            for (var x = 0; x < 3; x++) {
                                var m = x + 1;
                                var dateMinusOneMonth = moment(from_date).subtract(m, 'months').format('YYYY-MM-DD');
                                if (dateMinusOneMonth) {
                                    that.arry_lastmonth[x] = dateMinusOneMonth;
                                }
                            }
                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "&f[AGI]=" + agi;
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                //var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                //this.getDataApi(`/api/aff/lr?${path}&f[ID]=1&f[RI]=${data.RI}`,
                //    function (d, s) {
                //        that.bool_fullLoading = false;
                //        if (s) {
                //            that.arry_details = d.D.Items;
                //            that.bool_showDetails = true;
                //        }
                //    });
                that.bool_showDetails = true;
            },
            showDetailsByPirodMonth(data, month) {
                var referID = this.defaultDetail.I;
                this.arry_details = [];
                var that = this;
                that.activeMonth = month;
            },
            renderStatus(statusCode) {
                return this.getLanguage['CPR']['RS' + statusCode];
            },
            DownloadAppIcon(url) {
                window.open(url, '_blank');
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CPR', 'R', type);
            },
            checkRequestStatus(status) {
                if (status == 1) {
                    return true;
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {

                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                    this.arr_CashPositionReportList = null;
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.str_FV[0].FV}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            getTTList() {
                this.dd_tt = [{ id: '1', label: this.getLanguage['TD']['TT1'] }, { id: '2', label: this.getLanguage['TD']['TT2'] }];
            },
            onFileSelected(event) {
                this.obj_ab['IU'] = null;
                this.selectedFile = this.validateFile(event);
                this.newImg = true;
            },
            closeAdd() {
                this.selectedFile = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getCashPositionList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF
                    ? this.bool_isSort
                        ? "sort-descending"
                        : "sort-ascending"
                    : "list"
                    }`; //here change the sort logo
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.obj_ab[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["CPR"][langKey]);
                    }
                }
            },
            getCashPositionList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var agi = '';


                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'BM' && this.str_FV[i].FV != '') {
                            var from_date = this.parseDateToJsonString(this.str_FV[i].FV);
                            var to_date = moment(from_date).endOf('month').format('YYYY-MM-DD hh:mm');

                            path += "&f[CTS_from]=" + from_date;
                            path += "&f[CTS_to]=" + to_date;
                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "&f[AGI]=" + agi;
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/cashposition/cprd?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_CashPositionReportList = d.D.Items;
                        }
                    });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCashPositionList();
            },
            newSearch() {
                if (!this.bool_isAMV && (this.str_FV[0].FV || this.hideBrand)) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;

                    this.getCashPositionList();
                }
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            formatMonth(date) {
                return moment(date).format('DD/MM')
            },
            formatTime(date) {
                return moment(date).format('hh:mm')
            },
            addRecord() {
                this.obj_ab = {
                    I: 0,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: 0,
                    TI: 0,
                    TO: 0,
                    SV: null,
                    RM: null
                };
                this.arry_type = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.newImg = false;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3) {
                        this.obj_ab.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_ab.AGIT);
                    }
                }
            },
            saveToExcel() {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var agi = '';

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'BM' && this.str_FV[i].FV != '') {
                            var from_date = this.parseDateToJsonString(this.str_FV[i].FV);
                            var to_date = moment(from_date).endOf('month').format('YYYY-MM-DD hh:mm');

                            path += "&f[CTS_from]=" + from_date;
                            path += "&f[CTS_to]=" + to_date;
                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "&f[AGI]=" + agi;
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[0].FV) {
                    window.open('/api/cashposition/cashpositionexcel?' + path, '_blank');
                }
                else {
                    alert(String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AFF"]['BN']));
                }

            },
            checkWholeNumber(num) {
                return !!(num % 1);
            },
            selectedStyle(month) {
                var actM = moment(this.activeMonth).format('MM');
                var selM = moment(month).format('MM');

                if (selM == actM) {
                    return 'warning'
                } else {
                    return 'info'
                }
            },
        }
    };
</script>

<style>
    .a {
        color: blue !important;
        cursor: pointer;
    }

    .tab-content .tab-pane {
        padding: 15px 0px;
    }

    .month-year-display {
        font-size: .76563rem !important;
        /*width: 200px !important;*/
    }
    .text-darkOrange {
        color: darkorange !important;
    }
    .text-red {
        color: rgb(229, 54, 54) !important;
    }
    .text-green {
        color: #248f48 !important;
    }

    .cp-sticky {
        bottom: 0;
        text-align: inherit;
        position: -webkit-sticky;
        position: sticky;
        z-index: 2;
    }

    .cp-positive {
        color: #20d27c !important;
    }

    .cp-negative {
        color: #ef5565 !important;
    }

    .cp-white {
        font-weight: normal !important;
        color: #FFFFFF !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/CashPosition.vue